module.exports = __webpack_public_path__ + "img/13.8bcc93f2.jpg";